import { darken } from "polished";
import * as React from "react";
import { NavLink, RouteComponentProps, withRouter } from "react-router-dom";
import { track } from "../../../analytics";
import styled from "../../../styled-components";
import IThemeProps from "../../../theme";
import * as queryString from "query-string";
import { AppContainer } from "../../../containers/App.container";
import { Subscribe } from "unstated";
import { media } from "../../../breakpoints";

interface IHeaderProps {
  theme?: IThemeProps;
}

const Header = styled.header<IHeaderProps>`
  background: transparent;
  padding: 60px 100px 40px;

  ${media.TABLET`
    padding: 20px;
    z-index: 10;
  `};
`;

const Nav = styled.nav`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const HeaderLinks = styled.div`
  align-items: center;
  display: flex;
  width: 130px;
  justify-content: space-between;
`;

const Welcome = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

interface ITeslaLinkProps {
  exact: boolean;
  theme?: IThemeProps;
  to: string;
}

const AcornsLink = styled(NavLink)<ITeslaLinkProps>`
  color: ${props => props.theme.colors.white};
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.25s ease;

  &:hover {
    color: ${props => darken(0.1, props.theme.colors.white)};
    cursor: pointer;
  }

  &.active {
    color: ${props => props.theme.colors.acornsGreen};
  }
`;

interface IFAQLinkProps {
  exact: boolean;
  theme?: IThemeProps;
  to: string;
}

const FAQLink = styled(NavLink)<IFAQLinkProps>`
  color: ${props => props.theme.colors.white};
  font-size: 14px;
  font-weight: 600;
  margin-left: 20px;
  text-decoration: none;
  transition: opacity 0.25s ease;

  &:hover {
    color: ${props => darken(0.1, props.theme.colors.white)};
    cursor: pointer;
  }

  &.active {
    color: ${props => props.theme.colors.acornsGreen};
  }
`;

interface IAcornsHeaderProps extends RouteComponentProps<{}> {
  context: AppContainer;
}

class AcornsHeader extends React.Component<IAcornsHeaderProps> {
  public constructor(props: IAcornsHeaderProps) {
    super(props);

    this.handleElementClick = this.handleElementClick.bind(this);
  }

  public componentDidMount() {
    if (
      !this.props.context.state.name &&
      queryString.parse(this.props.history.location.search).name
    ) {
      const name = queryString.parse(this.props.history.location.search).name;
      if (name) {
        this.props.context.updateName(name[0]);
      }
    }
  }

  public handleElementClick(destination: string) {
    track("Primary Nav Item Clicked", { destination });
  }

  public render() {
    return (
      <Header>
        <Nav>
          <Welcome>
            {this.props.context.state.name &&
            this.props.history.location.pathname !== "/acorns/faq"
              ? `Welcome, ${this.props.context.state.name}!`
              : null}
          </Welcome>
          <HeaderLinks>
            <AcornsLink
              exact={true}
              to={"/acorns"}
              onClick={event => this.handleElementClick("acorns")}
            >
              SIGN UP
            </AcornsLink>

            <FAQLink
              exact={true}
              to="/acorns/faq"
              onClick={event => this.handleElementClick("acorns/faq")}
            >
              FAQ
            </FAQLink>
          </HeaderLinks>
        </Nav>
      </Header>
    );
  }
}

export default withRouter(props => (
  <Subscribe to={[AppContainer]}>
    {(app: AppContainer) => <AcornsHeader {...props} context={app} />}
  </Subscribe>
));



// WEBPACK FOOTER //
// ./src/pages/Acorns/AcornsHeader/AcornsHeader.tsx